interface SimpleObject {
  [key: string]: any;
}

function objectFromEntries(entries: any[][]): SimpleObject {
  const initValue: SimpleObject = {};

  if (!entries) {
    return {};
  }

  return entries.filter(Boolean).reduce((acc, [key, value]) => {
    acc[key] = value;
    return acc;
  }, initValue);
}

export default objectFromEntries;
